import React, { Component } from 'react';
import Modal from 'react-responsive-modal';
import {number_format,number_input_format} from '../helper/format';
import $ from 'jquery';

export default class Togetherlinepopup extends Component {
    constructor(props)
    {
        super(props);
        this.state = {
            open: false,
            product_index: 0,
            select_product_index: 0,
            select_product: null
        };

        //
        this.products = [
            {
                idx: 0,
                name: "미적용",
                price: 0,
                internet_discount: 0,
                discounts: [0]
            },
            {
                idx: 1,
                name: "스마트다이렉트 100M",
                price: 22000,
                internet_discount: 5610,
                discounts: [5500,14300,16500]
            },
            {
                idx: 2,
                name: "GIGA라이트 500M",
                price: 33000,
                internet_discount: 11110,
                discounts: [5500,16500,22000]
            },
            {
                idx: 3,
                name: "GIGA 1G",
                price: 38500,
                internet_discount: 13310,
                discounts: [5500,16500,22000,25300]
            }
        ];
    }
    Open(product_index)
    {
        this.setState({
            open: true,
            product_index: product_index
        });
    }
    Close()
    {
        this.setState({
            open: false
        });
    }
    onSelectLine(item, index)
    {
        this.setState({
            select_product_index: index,
            select_product: item
        });
    }
    Apply()
    {
        this.props.onLineChanged(this.state.select_product)
        this.Close();
    }
    render()
    {
        const self = this;
        return (
            <Modal open={this.state.open} onClose={()=>{self.Close()}} center>
                <div className="modal-dialog modal-md mb0">
                    <div className="popupPadding3">
                        <div className="md-popup-header"> &nbsp;인터넷 상품 선택</div>
                        <div className="md-popup-contents pt0 pl0">
                            <table className="table priceTable font14">
                                <tbody>
                                    {self.products.map((item, index)=>{
                                        if( self.state.product_index == 3 && index > 1 ) {
                                            return null;
                                        } else {
                                            return (
                                            <tr onClick={()=>{self.onSelectLine(item, item.idx)}} key={index}>
                                                <td><b>{item.name}</b></td>
                                                <td>{number_input_format(item.price)} 원</td>
                                            </tr>);
                                        }
                                    })}
                                </tbody>
                            </table>

                            <div className="pt15 pb15  border-top-1 border-bottom-1 bgf5">
                                <div className="row pl15">
                                    <div className="col-xs-6">
                                        <b>월 이용료</b>
                                    </div>
                                    <div className="col-xs-6 text-right">
                                        {(self.products[self.state.select_product_index].price == 0) ? <b>0 원</b>  :
                                        <b>{number_input_format(self.products[self.state.select_product_index].price)} 원</b>}
                                    </div>
                                </div>
                            </div>

                            <br/>

                            <div className="pt15 pb15">
                                <div className="row text-center">
                                   <a href="#applyPrice" onClick={()=>{self.Apply()}} className="btn btn-bar btn-md btn-select2">확인</a>&nbsp;&nbsp;&nbsp;&nbsp;
                                   <a href="#cancel" onClick={()=>{self.Close()}} className="btn btn-cancel btn-md btn-select2">취소</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        )
    }
}
